import React from "react";

import { SvgWrapper } from "../styles";

interface SvgComponentProps {
  height: number;
  width: number;
  color: string;
}

const IconDocumentUpload = (props: SvgComponentProps) => {
  const { width, height, color } = props;

  return (
    <SvgWrapper>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        fill="none"
        viewBox="0 0 22 22"
      >
        <path
          fill={color}
          d="M8 16.75c-.41 0-.75-.34-.75-.75v-4.19l-.72.72c-.29.29-.77.29-1.06 0a.754.754 0 010-1.06l2-2c.21-.21.54-.28.82-.16.28.11.46.39.46.69v6c0 .41-.34.75-.75.75z"
        ></path>
        <path
          fill={color}
          d="M10 12.75c-.19 0-.38-.07-.53-.22l-2-2a.754.754 0 010-1.06c.29-.29.77-.29 1.06 0l2 2c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22z"
        ></path>
        <path
          fill={color}
          d="M14 21.75H8C2.57 21.75.25 19.43.25 14V8C.25 2.57 2.57.25 8 .25h5c.41 0 .75.34.75.75s-.34.75-.75.75H8C3.39 1.75 1.75 3.39 1.75 8v6c0 4.61 1.64 6.25 6.25 6.25h6c4.61 0 6.25-1.64 6.25-6.25V9c0-.41.34-.75.75-.75s.75.34.75.75v5c0 5.43-2.32 7.75-7.75 7.75z"
        ></path>
        <path
          fill={color}
          d="M21 9.75h-4c-3.42 0-4.75-1.33-4.75-4.75V1c0-.3.18-.58.46-.69.28-.12.6-.05.82.16l8 8A.751.751 0 0121 9.75zm-7.25-6.94V5c0 2.58.67 3.25 3.25 3.25h2.19l-5.44-5.44z"
        ></path>
      </svg>
    </SvgWrapper>
  );
};

export default IconDocumentUpload;
